module.exports = __webpack_public_path__ + "img/ckb.c5aa95d9.svg";